// extracted by mini-css-extract-plugin
module.exports = {"swiper":"moviesSwipper_swiper__22tWb","next":"moviesSwipper_next__2mXIJ","prev":"moviesSwipper_prev__mIsIO","hide":"moviesSwipper_hide__3sA1a"};